export const acbelProducts = [
  {
    id: `crps-550`,
    name: { de: `CRPS 550W`, en: `CRPS 550W`, es: `CRPS 550W` },
    description: {
      de: `550W CRPS (Common Redundant Power Supply) Modul. Hot-Swap-fähig. 80+ Platinum Effizienz.`,
      en: `550W CRPS (Common Redundant Power Supply) Module. Hot-swap capable. 80+ Platinum efficiency.`,
      es: `Módulo CRPS (Common Redundant Power Supply) 550W. Capacidad hot-swap. Eficiencia 80+ Platinum.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `550W | CRPS | 80+ Platinum | Hot-Swap`,
    imageUrl: `/images/products/psu/crps-550.jpg`,
    images: [`/images/products/psu/crps-550.jpg`],
    datasheetUrl: `/datasheets/psu/R1CA2301A-B_R1CA2401A-B_R1CA2551K_R1CA2801A-B_R1CA2122A_Specification_01.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `crps-800`,
    name: { de: `CRPS 800W`, en: `CRPS 800W`, es: `CRPS 800W` },
    description: {
      de: `800W CRPS Modul. Hot-Swap-fähig. 80+ Platinum Effizienz. Für moderne Server-Infrastrukturen.`,
      en: `800W CRPS Module. Hot-swap capable. 80+ Platinum efficiency. For modern server infrastructures.`,
      es: `Módulo CRPS 800W. Capacidad hot-swap. Eficiencia 80+ Platinum. Para infraestructuras de servidor modernas.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `800W | CRPS | 80+ Platinum | Hot-Swap`,
    imageUrl: `/images/products/psu/crps-800.jpg`,
    images: [`/images/products/psu/crps-800.jpg`],
    datasheetUrl: `/datasheets/psu/R1CA2301A-B_R1CA2401A-B_R1CA2551K_R1CA2801A-B_R1CA2122A_Specification_01.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `crps-1200`,
    name: { de: `CRPS 1200W`, en: `CRPS 1200W`, es: `CRPS 1200W` },
    description: {
      de: `1200W CRPS Modul. Hot-Swap-fähig. 80+ Platinum Effizienz. Hohe Leistung für Server-, Storage- und Networking-Anwendungen.`,
      en: `1200W CRPS Module. Hot-swap capable. 80+ Platinum efficiency. High power for server, storage, and networking applications.`,
      es: `Módulo CRPS 1200W. Capacidad hot-swap. Eficiencia 80+ Platinum. Alta potencia para aplicaciones de servidor, almacenamiento y networking.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `1200W | CRPS | 80+ Platinum | Hot-Swap`,
    imageUrl: `/images/products/psu/crps-1200.jpg`,
    images: [`/images/products/psu/crps-1200.jpg`],
    datasheetUrl: `/datasheets/psu/R1CA2301A-B_R1CA2401A-B_R1CA2551K_R1CA2801A-B_R1CA2122A_Specification_01.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
  id: `pdb-r2c-housing`,
  name: {
    de: `AcBel PDB-R2C Housing`,
    en: `AcBel PDB-R2C Housing`,
    es: `AcBel PDB-R2C Housing`
  },
  description: {
    de: `PDB-R2C Housing / Power Distribution Backplane für R1C Series Netzteile. Geeignet für Server-, Storage-, Networking- und IPC-Anwendungen.`,
    en: `PDB-R2C housing / power distribution backplane for R1C Series power supplies. Suitable for server, storage, networking, and IPC applications.`,
    es: `Housing / power distribution backplane PDB-R2C para fuentes de poder de la serie R1C. Adecuado para aplicaciones de servidor, almacenamiento, networking e IPC.`
  },
  category: `Industrial PSU Housing`,
  application: `power-supply`,
  specs: `PDB-R2C | 300W-1200W | 76.9 x 265 x 83.7 mm | For R1C Series`,
  imageUrl: `/images/products/psu/pdb-r2c-housing.jpg`,
  images: [`/images/products/psu/pdb-r2c-housing.jpg`],
  datasheetUrl: `/datasheets/psu/R2CU4301A_R2CU4401A_R2CU4551A_R2CU4801A_R2CU4122A_Specification_01.pdf`,
  productUrl: `https://www.acbel.com`,
  price: null
 }
];

export const acbelCatalogCrpsProducts = [
  {
    id: `fsl032`,
    name: {
      de: `Acbel FSL032 Platinum 550W CRPS Module`,
      en: `Acbel FSL032 Platinum 550W CRPS Module`,
      es: `Acbel FSL032 Platinum 550W CRPS Module`
    },
    description: {
      de: `550W CRPS Modul mit 80+ Platinum Effizienz für Server-, Storage- und Networking-Anwendungen.`,
      en: `550W CRPS module with 80+ Platinum efficiency for server, storage, and networking applications.`,
      es: `Módulo CRPS de 550W con eficiencia 80+ Platinum para aplicaciones de servidor, almacenamiento y networking.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `550W | CRPS | 80+ Platinum | 12V/12VSB`,
    imageUrl: `/images/products/psu/fsl032.jpg`,
    images: [`/images/products/psu/fsl032.jpg`],
    datasheetUrl: `/datasheets/psu/acbel-R2CU4551A-platinum-550w-crps-catalog.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `fsl034`,
    name: {
      de: `Acbel FSL034 Platinum 800W CRPS Module`,
      en: `Acbel FSL034 Platinum 800W CRPS Module`,
      es: `Acbel FSL034 Platinum 800W CRPS Module`
    },
    description: {
      de: `800W CRPS Modul mit 80+ Platinum Effizienz für professionelle Infrastruktur- und Server-Anwendungen.`,
      en: `800W CRPS module with 80+ Platinum efficiency for professional infrastructure and server applications.`,
      es: `Módulo CRPS de 800W con eficiencia 80+ Platinum para aplicaciones profesionales de infraestructura y servidor.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `800W | CRPS | 80+ Platinum | 12V/12VSB`,
    imageUrl: `/images/products/psu/fsl034.jpg`,
    images: [`/images/products/psu/fsl034.jpg`],
    datasheetUrl: `/datasheets/psu/acbel-R2CU4551A-platinum-550w-crps-catalog.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `fsh018`,
    name: {
      de: `Acbel FSH018 Platinum 1600W CRPS Module`,
      en: `Acbel FSH018 Platinum 1600W CRPS Module`,
      es: `Acbel FSH018 Platinum 1600W CRPS Module`
    },
    description: {
      de: `1600W CRPS Modul mit 80+ Platinum Effizienz für High-Performance-Server und Rechenzentrumsanwendungen.`,
      en: `1600W CRPS module with 80+ Platinum efficiency for high-performance servers and data center applications.`,
      es: `Módulo CRPS de 1600W con eficiencia 80+ Platinum para servidores de alto rendimiento y aplicaciones de centro de datos.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `1600W | CRPS | 80+ Platinum | 12V/12VSB`,
    imageUrl: `/images/products/psu/fsh018.jpg`,
    images: [`/images/products/psu/fsh018.jpg`],
    datasheetUrl: `/datasheets/psu/acbel-R2CU4551A-platinum-550w-crps-catalog.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `fsm039`,
    name: {
      de: `Acbel FSM039 Platinum 1600W CRPS Module`,
      en: `Acbel FSM039 Platinum 1600W CRPS Module`,
      es: `Acbel FSM039 Platinum 1600W CRPS Module`
    },
    description: {
      de: `1600W CRPS Modul mit 80+ Platinum Effizienz, ausgelegt für leistungsstarke Server- und Storage-Plattformen.`,
      en: `1600W CRPS module with 80+ Platinum efficiency, designed for high-performance server and storage platforms.`,
      es: `Módulo CRPS de 1600W con eficiencia 80+ Platinum, diseñado para plataformas de servidor y almacenamiento de alto rendimiento.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `1600W | CRPS | 80+ Platinum | 12V/12VSB`,
    imageUrl: `/images/products/psu/fsm039.jpg`,
    images: [`/images/products/psu/fsm039.jpg`],
    datasheetUrl: `/datasheets/psu/acbel-R2CU4551A-platinum-550w-crps-catalog.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `fsj014`,
    name: {
      de: `Acbel FSJ014 Platinum 2000W CRPS Module`,
      en: `Acbel FSJ014 Platinum 2000W CRPS Module`,
      es: `Acbel FSJ014 Platinum 2000W CRPS Module`
    },
    description: {
      de: `2000W CRPS Modul mit 80+ Platinum Effizienz für hochverfügbare Server-, Storage- und Networking-Anwendungen.`,
      en: `2000W CRPS module with 80+ Platinum efficiency for high-availability server, storage, and networking applications.`,
      es: `Módulo CRPS de 2000W con eficiencia 80+ Platinum para aplicaciones de servidor, almacenamiento y networking de alta disponibilidad.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `2000W | CRPS | 80+ Platinum | 12V/12VSB`,
    imageUrl: `/images/products/psu/fsj014.jpg`,
    images: [`/images/products/psu/fsj014.jpg`],
    datasheetUrl: `/datasheets/psu/acbel-R2CU4551A-platinum-550w-crps-catalog.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
  {
    id: `fsm033`,
    name: {
      de: `Acbel FSM033 Platinum 2000W CRPS Module`,
      en: `Acbel FSM033 Platinum 2000W CRPS Module`,
      es: `Acbel FSM033 Platinum 2000W CRPS Module`
    },
    description: {
      de: `2000W CRPS Modul mit 80+ Platinum Effizienz für professionelle Server- und Infrastruktur-Umgebungen.`,
      en: `2000W CRPS module with 80+ Platinum efficiency for professional server and infrastructure environments.`,
      es: `Módulo CRPS de 2000W con eficiencia 80+ Platinum para entornos profesionales de servidor e infraestructura.`
    },
    category: `Industrial PSU`,
    application: `power-supply`,
    specs: `2000W | CRPS | 80+ Platinum | 12V/12VSB`,
    imageUrl: `/images/products/psu/fsm033.jpg`,
    images: [`/images/products/psu/fsm033.jpg`],
    datasheetUrl: `/datasheets/psu/acbel-R2CU4551A-platinum-550w-crps-catalog.pdf`,
    productUrl: `https://www.acbel.com`,
    price: null
  },
];
